export default __webpack_public_path__ + "static/16 - Gázkazán-48b85dd96d9c8390704dd26fe2dd7f5f.jpg";